import { render, staticRenderFns } from "./checkInfo.vue?vue&type=template&id=2c38ab62&scoped=true&"
import script from "./checkInfo.vue?vue&type=script&lang=js&"
export * from "./checkInfo.vue?vue&type=script&lang=js&"
import style0 from "./checkInfo.vue?vue&type=style&index=0&id=2c38ab62&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38ab62",
  null
  
)

export default component.exports